export default __webpack_public_path__ + "static/media/Crt1.24ead238.png";